<ng-template appShowpopup></ng-template>
<header class="fixed top-0 z-30 w-full px-6 py-4 bg-header_bg shadow">
    <div class="salem sm:flex items-center justify-between">
        <img [src]="_commonServices.Images.FRACTAL_LOGO" alt="" >
        <div class="flex gap-6 items-center">
            <div>
                <img [src]="_commonServices.Images.NOTIFICATION_ICON" alt="notification" class="my-auto h-9 w-9 ">
            </div>

            <div class="flex gap-2">
                <div *ngIf="loginUser?.role == 'SUPER_ADMIN'">
                    <img [src]="loginUser.profilePicture?.filePreviewUrl ? loginUser.profilePicture.filePreviewUrl : _commonServices.Images.AVATAR"   alt="avatar" class="h-10 w-10 rounded-full" >
                </div>
                <div>
                    <div class="flex cursor-pointer gap-1" (click)="togglePopup()" #dropdownElement appOutsideClick
                        (appOutsideClick)="closeDropdown()">
                        <h1 class="dashBoradNameText classForAvoidHostListener">
                            {{loginUser?.fullName==null ? 'N/A' : loginUser?.fullName.length>25 ?
                            (loginUser?.fullName | slice:0:25)+ "..." : loginUser?.fullName}}</h1>
                        <img [src]="_commonServices.Images.DROPDOWN_ICON" alt=""
                            [ngClass]="{'transform rotate-180':isOpen}"
                            class="transition-transform duration-200 classForAvoidHostListener">
                    </div>
                    <div>
                        <p class="text-xs text-secondary_Light_Text_Color font-medium">  {{ 
                            loginUser?.role == 'SUPER_ADMIN' 
                              ? 'Super Admin' 
                              :''
                          }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="isOpen">
        <div class=" absolute bg-white  rounded-lg border-gray-300 border
        shadow mt-1 right-5 top-16 p-4">
            <div class="flex gap-2">
                <div>
                    <img [src]="_commonServices.Images.AVATAR" alt="avatar" class="h-8 w-8 mt-2">
                </div>
                <div>
                    <div class="flex gap-2" (click)="togglePopup()">
                        <h1 class="dashBoradNameText classForAvoidHostListener">
                            {{loginUser?.fullName==null ? 'N/A' : loginUser?.fullName.length>25 ?
                            (loginUser?.fullName | slice:0:25)+ "..." : loginUser?.fullName}}</h1>
                        <p class="mt-1 opacity-50">-</p>
                        <p class="text-xs text-secondary_Light_Text_Color font-medium mt-2">{{ 
                             loginUser?.role == 'SUPER_ADMIN' 
                              ? 'Super Admin' 
                              :''
                          }}</p>
                    </div>
                    <div>
                        <p class="text-xs text-secondary_Light_Text_Color font-medium">{{loginUser.email}}</p>
                    </div>
                </div>
            </div>
            <ul class="mt-3">
                <!-- <li *ngIf="loginUser?.userRole != 'COLLEGE_ADMIN'" class="text-text_secondary_gray text-base font-medium cursor-pointer block px-2 py-2 hover:bg-gray-100"
                    routerLinkActive="active" (click)="openChangePasswordPopup()">
                    <div class="flex gap-2">
                            <img [src]="_commonServices.Images.CHANGE_PASSWORD_ICON" alt="change password">
                        <p class="text-sm 2xl:text-base">Change Password</p>
                    </div>
                </li> -->
                <li class="text-text_secondary_gray text-base font-medium cursor-pointer block px-2 py-2 hover:bg-gray-100"
                    (click)="logOut()" routerLinkActive="active">
                     <div class="flex gap-2">
                         <img [src]="_commonServices.Images.SIGN_OUT_ICON" alt="sign out">
                        <p class="text-sm 2xl:text-base">Sign Out</p>
                     </div>
                </li>
            </ul>
        </div>
    </div>
</header>
